import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";

const RESOURCE_LABELS = {
  order: "Pedidos Despachados / mês",
  restaurant: "Restaurantes",
  delivery_center: "Centrais de Entrega",
  driver: "Motoristas",
  cost_category: "Categorias de Custo",
  cost_supplier: "Fornecedores",
  cost_entry: "Lançamentos de Custo / mês",
  label: "Etiquetas / mês",
  fiscal_ticket: "Notas Fiscais / mês",
  uber_delivery: "Entregas Uber / mês",
  whatsapp_instance: "Instâncias WhatsApp",
};

const getProgressColor = (pct) => {
  if (pct >= 90) return "error";
  if (pct >= 70) return "warning";
  return "primary";
};

export default function UsageBars({ usage }) {
  if (!usage || Object.keys(usage).length === 0) return null;

  // Filter out resources with limit=0 (disabled)
  const activeResources = Object.entries(usage).filter(
    ([, data]) => data.limit !== 0
  );

  if (activeResources.length === 0) return null;

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Uso de Recursos
      </Typography>
      <Stack spacing={2}>
        {activeResources.map(([key, data]) => {
          const label = RESOURCE_LABELS[key] || key;
          const pct = data.unlimited ? 0 : Math.min(data.percentage, 100);

          return (
            <Box key={key}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 0.5 }}
              >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {label}
                </Typography>
                {data.unlimited ? (
                  <Chip
                    icon={<AllInclusiveIcon sx={{ fontSize: "14px !important" }} />}
                    label="Ilimitado"
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: "0.7rem" }}
                  />
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    {data.current} / {data.limit}
                  </Typography>
                )}
              </Stack>
              {!data.unlimited && (
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  color={getProgressColor(pct)}
                  sx={{ height: 6, borderRadius: 3 }}
                />
              )}
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
